import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyMock } from './currency.factory'
import { type UnbilledPurchaseOrder } from '../../models'

export const UnbilledPurchaseOrderMock =
  Factory.Sync.makeFactory<UnbilledPurchaseOrder>({
    uuid: Factory.each(() => faker.random.uuid()),
    id: Factory.each(() => faker.random.number()),
    currency: Factory.each(() => CurrencyMock.build().name),
    number: '',
    total_amount: Factory.each(() => faker.random.number().toString()),
    pref_vendor: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.company.companyName(),
    })),
  }).withDerivation1(['id'], 'number', (id) => {
    return `PF${id}`
  })
